import React from "react";
import { useGameState } from "context/GameContext";
// Comps
import { IonButton } from "@ionic/react";
// Css
import classes from "./Actions.module.scss";
// WebSocket
import { ws } from "api/webSocket";

const Actions: React.FC = () => {
  const { player, players, hostId, code } = useGameState();

  return (
    <>
      {player?.id === hostId && (
        <IonButton
          className={classes.button}
          disabled={players.length < 5}
          onClick={() => ws.startGame(code)}
          size="small"
        >
          START
        </IonButton>
      )}
    </>
  );
};

export default Actions;
